import { render, staticRenderFns } from "./grupal.vue?vue&type=template&id=009d29a8&"
import script from "./grupal.vue?vue&type=script&lang=js&"
export * from "./grupal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports